<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Please fill in your details below</small>
                            </div>
                            <form role="form">
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="First Name"
                                            v-model="input.firstName"
                                            addon-left-icon="ni ni-hat-3">
                                </base-input>
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="Last Name"
                                            v-model="input.lastName"
                                            addon-left-icon="ni ni-hat-3">
                                </base-input>
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="Email"
                                            v-model="input.emailAddress"
                                            addon-left-icon="ni ni-email-83">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            placeholder="Password"
                                             v-model="input.password"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                               
                                <base-checkbox>
                                    <span>I agree with the
                                        <a href="#">Privacy Policy</a>
                                    </span>
                                </base-checkbox>
                                <div class="text-center">
                                    <base-button type="primary" v-on:click="register" class="my-4">Create account</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import axios from 'axios';
    export default {
        name: 'Register',
        data() {
            return {
                input: {
                    firstName: "",
                    lastName: "",
                    emailAddress: "",
                    password: ""
                }  
            };
        },
        methods: {
            register() {
                var account = {firstName: this.input.firstName, lastName: this.input.lastName, emailAddress: this.input.emailAddress, password: this.input.password};
                var bodyData = JSON.stringify(account);
                this.$http.post('/account',bodyData)
                .then(response => {
                    if (response.status == 200)
                    {
                        localStorage.clear();
                        localStorage.token = response.data.token;
                        this.$currentUser.userId = response.data.person.id;
                        this.$currentUser.accountGroup = response.data.person.owningAccount.id;
                        this.$router.replace(this.$route.query.redirect || '/secure')
                    }
                    
                })
                .catch(e => {
                    console.error("Ouchy : " + e);
                  
                })
            }
        }
};
</script>
<style>
</style>
